export default (apiFetch) => async (payload) => {
  const response = await apiFetch({
    endpoint: "contact-us",
    method: "POST",
    body: payload,
    headers: {},
  });

  return await response.json();
};
